<template>
    <div class="test">
        <div class="container">
            <v-textarea
                v-model="inputText"
                label="Tekst za stampu"
                rows="3"
                outlined
                hide-details
            />

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                @click="chooseCertificate"
            >
                Choose Certificate
            </v-btn>
            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                @click="loading = false; response = null;"
            >
                Reset
            </v-btn>
            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                @click="barcode"
            >
                Barcode
            </v-btn>
            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                :loading="loading"
                @click="printText"
            >
                Print Text
            </v-btn>
            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                :loading="loading"
                @click="printOrder"
            >
                Print Last Order
            </v-btn>

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                :loading="loading"
                @click="clearDisplay"
            >
                Clear Display
            </v-btn>

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                @click="writeTextToExternalDisplay"
            >
                Write Text To External Display
            </v-btn>

            <!-- <v-btn
                text
                class="mt-2"
                block
                color="primary"
                :loading="loading"
                @click="insertProduct"
            >
                Insert Article
            </v-btn>

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                :loading="loading"
                @click="insertProducts"
            >
                Insert Articles
            </v-btn>

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                @click="loadProduct"
            >
                Load Article
            </v-btn>

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                @click="loadProducts"
            >
                Load Articles
            </v-btn>

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                @click="printFiscalReceipt"
            >
                Print Fiscal Receipt
            </v-btn>

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                @click="printReclamatoryReceipt"
            >
                Print Reclamatory Receipt
            </v-btn>

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                @click="depositMoney"
            >
                Deposit Money
            </v-btn>

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                @click="withdrawMoney"
            >
                Withdraw Money
            </v-btn>

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                @click="printBalanceSheet"
            >
                Print Balance Sheet
            </v-btn>

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                @click="printDailyReport"
            >
                Print Daily Report
            </v-btn>

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                @click="printPeriodicReport"
            >
                Print Periodic Report
            </v-btn>

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                :loading="loading"
                @click="printNonfiscalText"
            >
                Print nonfiscal text
            </v-btn>

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                :loading="loading"
                @click="printDuplicateFiscalReceipt"
            >
                Print Duplicate Fiscal Receipt
            </v-btn>

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                :loading="loading"
                @click="printDuplicateReclamatoryReceipt"
            >
                Print Duplicate Reclamatory Receipt
            </v-btn>

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                :loading="loading"
                @click="printDuplicateBalanceSheet"
            >
                Print Duplicate Balance Sheet
            </v-btn>

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                :loading="loading"
                @click="printDuplicateDailyReport"
            >
                Print Duplicate Daily Report
            </v-btn>

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                :loading="loading"
                @click="printDuplicatePeriodicReport"
            >
                Print Duplicate Periodic Report
            </v-btn>

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                @click="getBasicInformation"
            >
                Get Device Info
            </v-btn>

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                @click="getDateAndTime"
            >
                Get date and time
            </v-btn>

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                @click="loadOnDisplay"
            >
                Load on display
            </v-btn> -->

            <v-btn
                text
                class="mt-2"
                block
                color="primary"
                @click="$router.push({ name: 'userLogin' })"
            >
                Back
            </v-btn>

            <v-divider class="my-2" />

            <div>
                {{ response }}
            </div>
        </div>
    </div>
</template>

<script>
import { AriaCapacitor } from '@codeus/aria-capacitor';
// import FiscalService from '@/services/FiscalService';
import Order from '@/models/Order';
import Product from '@/models/Product';
// import { BarcodeScanner } from '@capacitor-community/barcode-scanner';
// import { BleClient } from '@capacitor-community/bluetooth-le';

export default {
    async created() {
        if (window.electron) {
            window.electron.on('el-test-done', (event, data) => {
                console.log(data);
            });
        }

        this.exampleProduct = Product.all()[0]
        this.exampleProduct2 = Product.all()[1]
        this.exampleOrder = Order.all()[Order.all().length - 1]
        // await BleClient.initialize({ androidNeverForLocation: true });
    },

    beforeDestroy() {
        // BarcodeScanner.showBackground();
        // BarcodeScanner.stopScan();
    },

    mounted() {},

    data() {
        return {
            text: 1,
            response: null,
            loading: false,
            address: 'DC:0D:30:4D:73:7A',
            inputText: 'LZR6PJK6',
            exampleProduct: null,
            exampleProduct2: null,
            exampleOrder: null
        };
    },

    methods: {
        async test() {
            this.loading = true
            this.response = await AriaCapacitor.echo('misko')
            this.loading = false
        },

        async chooseCertificate() {
            this.response = null
            this.loading = true

            const options = {
                url: 'http://devesdc.sandbox.suf.purs.gov.rs:8888/074eb421-1fc0-4e0e-80b6-8ce8bfd820a0/api/v3',
                pac: 'LZR6PJK6',
                certAlias: null,
                sdc: 'VSDC',
            }

            this.response = await AriaCapacitor.chooseCertificate({ options })

            this.loading = false

            // window.electron.invoke('el-cert-choose', this.inputText).then((result) => {
            //     this.response = result
            //     if(this.response.success) {
            //         AppStorage.native().setItem('pac', 'B5CCZA')
            //         AppStorage.native().setItem('cert', result.cert)
            //         AppStorage.native().setItem('key', result.key)
            //         FiscalService.init()
            //     }
            // })
        },

        async barcode() {
            // this.response = null
            // this.loading = true

            // // Check camera permission
            // // This is just a simple example, check out the better checks below
            // await BarcodeScanner.checkPermission({ force: true });

            // // make background of WebView transparent
            // // note: if you are using ionic this might not be enough, check below
            // BarcodeScanner.hideBackground();

            // const result = await BarcodeScanner.startScan(); // start scanning and wait for a result

            // this.result = result.hasContent ? result.content : 'nothing scanned';

            // this.loading = false
        },

        async printText() {
            // const bluetoothEnabled = await BleClient.isEnabled();
            // if(!bluetoothEnabled) {
            //     await BleClient.enable();
            // }

            const printer = {
                width: 48,
                charsPerLine: 32,
                dpi: 203,
                ipAddress: null,
                qrCodeSize: locale === 'sr' ? 50 : 30,
            }

            this.response = await AriaCapacitor.print({
                printer,
                data: {
                    text: this.inputText,
                    qrCode: this.inputText,
                    qrCodeEmbed: 0,
                    highlight: null,
                    footer: null
                }
            })
        },

        async printOrder() {
            // const bluetoothEnabled = await BleClient.isEnabled();
            // if(!bluetoothEnabled) {
            //     await BleClient.enable();
            // }

            let textToPrint = Order.all()[Order.all().length - 1].toText({
                isReceipt: true,
                isCopy: false,
                printingSector: null
            }, 32);

            const printer = {
                width: 48,
                charsPerLine: 32,
                dpi: 203,
                ipAddress: null,
                qrCodeSize: locale === 'sr' ? 50 : 30,
            }

            AriaCapacitor.print({
                printer,
                data: {
                    text: textToPrint,
                    qrCode: this.inputText,
                    qrCodeEmbed: 0,
                    highlight: null,
                    footer: null
                }
            })
        },

        async clearDisplay() {
            this.response = await window.electron.invoke('external-display:clear');
        },

        async writeTextToExternalDisplay() {
            this.response = await window.electron.invoke('external-display:write-text', [this.inputText.split('\n')[0], '123.33'], [this.inputText.split('\n')[1], '22.00']);
        },

        async insertProduct() {
            this.response = await window.electron.invoke('fsl-insert-product', this.exampleProduct);
        },

        async insertProducts() {
            this.response = await window.electron.invoke('fsl-insert-products', [this.exampleProduct, this.exampleProduct2]);
        },

        async loadProduct() {
            this.response = await window.electron.invoke('fsl-load-product', 3);
        },

        async loadProducts() {
            this.response = await window.electron.invoke('fsl-load-products', [3, 4]);
        },

        async printFiscalReceipt() {
            this.response = await window.electron.invoke('fsl-print-fiscal-receipt', this.exampleOrder.getRegisterRequestBa());
        },

        async printReclamatoryReceipt() {
            this.response = await window.electron.invoke('fsl-print-reclamatory-receipt', this.exampleOrder.getRegisterRequestBa());
        },

        async depositMoney() {
            this.response = await window.electron.invoke('fsl-deposit-money', 100);
        },

        async withdrawMoney() {
            this.response = await window.electron.invoke('fsl-withdraw-money', 20);
        },

        async printBalanceSheet() {
            this.response = await window.electron.invoke('fsl-print-balance-sheet');
        },

        async printDailyReport() {
            this.response = await window.electron.invoke('fsl-print-daily-report');
        },

        async printPeriodicReport() {
            this.response = await window.electron.invoke('fsl-print-periodic-report', { from: '1. 11. 2023. 00:00:00', to: '7. 11. 2023. 23:59:59' });
        },

        async printNonfiscalText() {
            this.response = await window.electron.invoke('fsl-print-text', 'Test 123')
        },

        async printDuplicateFiscalReceipt() {
            this.response = await window.electron.invoke('fsl-print-duplicate-fiscal-receipt', 222, false);
        },

        async printDuplicateReclamatoryReceipt() {
            this.response = await window.electron.invoke('fsl-print-duplicate-fiscal-receipt', 222, true);
        },

        async printDuplicateBalanceSheet() {
            this.response = await window.electron.invoke('fsl-print-duplicate-balance-sheet');
        },

        async printDuplicateDailyReport() {
            this.response = await window.electron.invoke('fsl-print-duplicate-daily-report', 444);
        },

        async printDuplicatePeriodicReport() {
            this.response = await window.electron.invoke('fsl-print-duplicate-periodic-report', 555);
        },

        async getBasicInformation() {
            this.response = await window.electron.invoke('fsl-get-basic-information');
        },

        async getDateAndTime() {
            this.response = await window.electron.invoke('fsl-get-date-and-time', this.exampleOrder.getRegisterRequestBa().items[0]);
        },

        async loadOnDisplay() {
            this.response = await window.electron.invoke('fsl-load-on-display', this.exampleOrder.getRegisterRequestBa().items[0]);
        }
    }
};
</script>

<style lang="scss" scoped>
.test {
    text-align: center;

    .container {
        max-width: 400px;
    }
}
</style>
